<template>
  <transition name="el-fade-in-linear">
    <div v-show="show">
      <el-container>
        <div>
          <el-image
            :src="require('@/assets/about_hd2x.png')"
            fit="fill">
          </el-image>
          <div class="about">
            <p class="n1">{{$t('el.d.about_about1')}}</p>
            <p class="n2">{{$t('el.d.about_about2')}}</p>
          </div>
        </div>
      </el-container>
      <el-container class="aboutInfo">
        <div class="company">
          <h3>{{$t('el.d.about_comName')}}</h3>
          <h4>{{$t('el.d.about_plat')}}</h4>
          <p class="info">
            {{$t('el.d.about_platInfo')}}
          </p>
          <el-container class="aboutBus">
            <div>
              <p class="title">{{$t('el.d.about_m1_c1')}}</p>
              <p class="content">
                {{$t('el.d.about_m1_c2')}}
              </p>
              <p class="bottomTitle">{{$t('el.d.about_m1_c3')}}</p>
            </div>
            <div class="middle">
              <p class="title">{{$t('el.d.about_m1_c4')}}</p>
              <p class="content">
                {{$t('el.d.about_m1_c5')}}
              </p>
              <p class="bottomTitle">{{$t('el.d.about_m1_c6')}}</p>
            </div>
            <div>
              <p class="title">{{$t('el.d.about_m1_c7')}}</p>
              <p class="content">
                {{$t('el.d.about_m1_c8')}}
              </p>
              <p class="bottomTitle">{{$t('el.d.about_m1_c9')}}</p>
            </div>
          </el-container>
        </div>
      </el-container>
      <el-container>
        <el-container class="about50">
          <div>
            <h4>{{$t('el.d.about_m2_c1')}}</h4>
            <p class="content">
              {{$t('el.d.about_m2_c2')}}
            </p>
          </div>
        </el-container>
        <el-container class="about50">
          <el-image :src="require('@/assets/about_p1_2x.png')" fit="fit"></el-image>
        </el-container>
      </el-container>
      <el-container>
        <el-container class="about50">
          <el-image :src="require('@/assets/about_p2_2x.png')" fit="fit"></el-image>
        </el-container>
        <el-container class="about50">
          <div>
            <h4>{{$t('el.d.about_m2_c3')}}</h4>
            <p class="content">
              {{$t('el.d.about_m2_c4')}}
            </p>
          </div>
        </el-container>
      </el-container>
      <el-container class="aboutPartner">
        <div>
          <h1 class="marginTB50">{{$t('el.d.about_partner')}}</h1>
          <div class="content">
            <h3 class="marginTB50">{{$t('el.d.about_partner_1')}}</h3>
            <div class="about30">
              <el-image :src="require('@/assets/1-1.png')" fit="fit" class="img1_1"></el-image>
              <el-image :src="require('@/assets/1-2.png')" fit="fit" class="img1_2"></el-image>
              <el-image :src="require('@/assets/1-3.png')" fit="fit" class="img1_3"></el-image>
            </div>
            <div>
              <el-image :src="require('@/assets/1-4.png')" fit="fit" class="img1_4"></el-image>
            </div>
          </div>
          <div class="content">
            <h3 class="marginTB50">{{$t('el.d.about_partner_2')}}</h3>
            <div class="about30">
              <el-image :src="require('@/assets/2-1.png')" fit="fit" class="img1_3"></el-image>
              <el-image :src="require('@/assets/2-2.png')" fit="fit" class="img1_3"></el-image>
              <el-image :src="require('@/assets/2-3.png')" fit="fit" class="img1_3"></el-image>
            </div>
            <div class="about30">
              <el-image :src="require('@/assets/2-4.png')" fit="fit" class="img1_3"></el-image>
              <el-image :src="require('@/assets/2-5.png')" fit="fit" class="img1_3"></el-image>
              <el-image :src="require('@/assets/2-6.png')" fit="fit" class="img1_3"></el-image>
            </div>
          </div>
          <div class="content">
            <h3 class="marginTB50">{{$t('el.d.about_partner_3')}}</h3>
            <div class="about30">
              <el-image :src="require('@/assets/3-1.png')" fit="fit" class="img1_3"></el-image>
              <el-image :src="require('@/assets/3-2.png')" fit="fit" class="img1_3"></el-image>
              <el-image :src="require('@/assets/3-3.png')" fit="fit" class="img1_3"></el-image>
            </div>
            <div class="about30">
              <el-image :src="require('@/assets/3-4.png')" fit="fit" class="img1_3"></el-image>
              <el-image :src="require('@/assets/3-5.png')" fit="fit" class="img1_3"></el-image>
              <el-image :src="require('@/assets/3-6.png')" fit="fit" class="img1_3"></el-image>
            </div>
            <div >
              <el-image :src="require('@/assets/3-7.png')" fit="fit" class="img1_4"></el-image>

            </div>
          </div>
        </div>
      </el-container>
      <el-container>
        <Footer id="footer"/>
      </el-container>
    </div>
  </transition>
</template>

<script>
  import Footer from '../components/Footer'

  export default {
    name: 'about',
    components: {Footer},
    data () {
      return {
        show: false,
        commandFlag: true,
        showNum: 9,
        list: [{name: 'el.jg.name1', info: 'el.jg.info1'},
          {name: 'el.jg.name2', info: 'el.jg.info2'},
          {name: 'el.jg.name3', info: 'el.jg.info3'},
          {name: 'el.jg.name4', info: 'el.jg.info4'},
          {name: 'el.jg.name5', info: 'el.jg.info5'},
          {name: 'el.jg.name6', info: 'el.jg.info6'},
          {name: 'el.jg.name7', info: 'el.jg.info7'},
          {name: 'el.jg.name8', info: 'el.jg.info8'},
          {name: 'el.jg.name9', info: 'el.jg.info9'},
          {name: 'el.jg.name10', info: 'el.jg.info10'},
          {name: 'el.jg.name11', info: 'el.jg.info11'},
          {name: 'el.jg.name12', info: 'el.jg.info12'},
          {name: 'el.jg.name13', info: 'el.jg.info13'},
          {name: 'el.jg.name14', info: 'el.jg.info14'},
          {name: 'el.jg.name15', info: 'el.jg.info15'},
          {name: 'el.jg.name16', info: 'el.jg.info16'},
          {name: 'el.jg.name17', info: 'el.jg.info17'},
          {name: 'el.jg.name18', info: 'el.jg.info18'},
          {name: 'el.jg.name19', info: 'el.jg.info19'},
          {name: 'el.jg.name20', info: 'el.jg.info20'},
          {name: 'el.jg.name21', info: 'el.jg.info21'},
          {name: 'el.jg.name22', info: 'el.jg.info22'},
          {name: 'el.jg.name23', info: 'el.jg.info23'},
          {name: 'el.jg.name24', info: 'el.jg.info24'},
          {name: 'el.jg.name25', info: 'el.jg.info25'},
          {name: 'el.jg.name26', info: 'el.jg.info26'},
          {name: 'el.jg.name27', info: 'el.jg.info27'},
          {name: 'el.jg.name28', info: 'el.jg.info28'},
          {name: 'el.jg.name29', info: 'el.jg.info29'},
          {name: 'el.jg.name30', info: 'el.jg.info30'}]
      }
    },
    mounted () {
      this.show = true
    },
    methods: {
      changeView: function () {
        this.commandFlag = !this.commandFlag
        if (this.commandFlag) {
          this.showNum = 9
        } else {
          this.showNum = this.list.length
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/page/About.vue